import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[70vh] md:min-h-[90vh] flex flex-col items-center justify-center px-4 pt-12 pb-10 md:pt-20 md:pb-16 overflow-hidden" data-id="element-44">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#0ea5e9]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-45" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-47">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-[#00d4ff] text-sm font-medium mb-8" data-id="element-48">
            <ZapIcon className="w-4 h-4" data-id="element-49" />
            <span data-id="element-50">El método técnico para profesionales estresados</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-8 leading-[1.1]" data-id="element-51">
            Cómo Resetear tu Sistema Nervioso y Eliminar el{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d4ff] to-[#0ea5e9]" data-id="element-52">
              Burnout Digital
            </span>{' '}
            en Solo 10 Minutos
          </h1>

          <p className="text-xl md:text-2xl text-gray-400 mb-4 font-light" data-id="element-53">
            Sin Suscripciones Eternas, Sin Videos Largos y Sin Meditaciones
            Aburridas.
          </p>

          <p className="text-lg text-gray-500 max-w-2xl mx-auto mb-12" data-id="element-54">
            Deja de pagar $70 USD al año por apps que solo añaden ruido a tu
            día. Aplica la neurociencia del{' '}
            <strong className="text-white font-semibold" data-id="element-55">
              Protocolo de Pausa
            </strong>{' '}
            y recupera tu soberanía mental con un solo pago de por vida. 100%
            Formato Ebook: Leer, Aplicar y Resetear.
          </p>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-gradient-to-r from-[#0ea5e9] to-[#0284c7] rounded-full overflow-hidden transition-all hover:shadow-[0_0_40px_rgba(14,165,233,0.4)]" data-id="element-56">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-57" />
            <span className="relative flex items-center gap-2" data-id="element-58">
              QUIERO RECUPERAR MI ENFOQUE AHORA
            </span>
          </motion.button>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-gray-500 animate-bounce" data-id="element-59">
        <ChevronDownIcon className="w-6 h-6" data-id="element-60" />
      </motion.div>
    </section>;
}